module.exports = __webpack_public_path__ + "img/Boeing_full_logo_(variant) 1.4f262772.svg";